<template>
    <div class="">
        <div style="height: 100vh;position: relative;overflow: hidden;">
            <el-row class="page-top" type="flex" justify="center" align="center">
                    <el-col :md="6" align="center" style="position: relative;">
                        <el-col :md="24" style="position: absolute;opacity: .2;letter-spacing: 5px;font-weight: bold;">
                            <h1 >NEWS CENTER</h1>
                        </el-col>
                        <el-col :md="24">
                            <h1 style="color: #fff;font-weight: bold;">{{$t('newscenter.toptitle')}}</h1>
                            <h6>NEWS CENTER</h6>
                            <h6>{{$t('newscenter.linfo')}}</h6>
                            
                        </el-col>
                    </el-col>
            </el-row>
            <el-row type="flex" justify="center" align="center" class="menu hidden-sm-and-down">
                <el-col :md="10"  align="center" class="item hover-hand"  @click.native="selectModel(0)" :class="idx == 0 ? 'lose':'active'">
                    <h4>{{$t('newscenter.topBar.left.top')}}  </h4>
                </el-col>
                <el-col :md="10"  align="center" class="item hover-hand" @click.native="selectModel(2)" :class="idx == 2 ? 'lose':'active'">
                    <h4>{{$t('newscenter.topBar.right.top')}}</h4>
                </el-col>
            </el-row>
            <el-row type="flex" justify="center">
                <div class="more-page">
                    <p class="iconfont mh-weibiaoti-1-18"></p>
                    <p class="iconfont mh-weibiaoti-1-19 one"></p>
                    <p class="iconfont mh-weibiaoti-1-19 two"></p>
                </div>
            </el-row>
        </div>
        
        <el-row class="cpn-news" id="boma" >
            <el-row type="flex" justify="center" class="mrow">
                <el-col :md="20" class="h-menu-title hidden-sm-and-down">
                    <div class="news-sub">DYNAMIC</div>
                    <div class="news-title" >
                        <div class="news-type hover-hand"   @click="selectCpn(0)" :class="cpnContentIdx == 0 ? 'active':''" >
                            {{$t('newscenter.topBar.left.left')}}
                        </div>
                        <div class="news-type hover-hand"   @click="selectCpn(1)" :class="cpnContentIdx == 1 ? 'active':''" >
                            {{$t('newscenter.topBar.left.right')}}
                        </div></div>
                </el-col>
                <el-col :md="20" class="m-menu-title hidden-md-and-up">
                    <el-col :xs="12" :sm="12"   @click.native="selectCpn(0)">
                        <div class="news-sub" :class="cpnContentIdx == 0 ? 'active':''">DYNAMIC</div>
                        <div class="news-title" :class="cpnContentIdx == 0 ? 'active':''" >
                            {{$t('newscenter.topBar.left.left')}}
                        </div>
                    </el-col>
                    <el-col :xs="12" :sm="12" @click.native="selectCpn(1)">
                        <div class="news-sub" :class="cpnContentIdx == 1 ? 'active':''">DYNAMIC</div>
                        <div class="news-title" :class="cpnContentIdx == 1 ? 'active':''">
                            {{$t('newscenter.topBar.left.right')}}
                        </div>
                    </el-col>
                    
                </el-col>
            </el-row>
            <el-row type="flex" justify="center" class="news-list" v-show="show">
                <el-col :md="20" :sm="22" :xs="22">
                    <el-row :gutter="20">
                        <el-col :md="12" :sm="24" :xs="24"  @mouseover.native="onHover(0,idx)" v-show="idx < 4"  v-for="(item,idx) in cpnCurrent" :key="idx" 
                         class="news-left item hover-hand"  >
                            <div class="left-main">
                                <div class="news-img hover-hand" v-if=" idx == 0" :style="{backgroundImage:'url('+item.imgPath+')'}" @click="redirect(item.id)"></div>
                                <div class="news-detail" style="width: 100%; height: 150px; " 
                                    >
                                    <el-col :md="22" :xs="21" :sm="22">
                                        <el-col :md="24" style="display: flex;align-items: center;">
                                            <div class="iconfont mh-rili" style="font-size: 20px;" :style="{color:newsIdx==idx && moduleIdx == 0?'#fff':'#BA4D48'}"/>
                                            <div style="padding-left: 5px;">{{item.inputTime}}</div>    
                                        </el-col>
                                        <el-col :md="24" class="content-title">
                                            <div  > <a target="_blank" :href="item.pagePath">{{item.title}}</a></div>
                                        </el-col>
                                        <el-col :md="24" :style="{'--clamp': 2}" class="content-msg"><a target="_blank" :href="item.pagePath">{{item.subContent}}</a></el-col>
                                    </el-col>
                                    <el-col :md="2" :xs="2" :sm="2" style="height: 100%;display: flex;align-items: center;" >
                                           <p class="iconfont mh-right "  style="font-size: 40px;" />
                                    </el-col>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
            <el-row type="flex" justify="center">
                <el-col :md="20" :sm="22" :xs="22" >
                    <div style="margin-top: 10px;text-align: right;">
                        <el-button type="text" style="color: #BA4D48;" > <a  href="newslist">查看更多>></a></el-button>
                    </div>
                </el-col>
            </el-row>
        </el-row>
        
        <div class="cpn-news" id="hml" style="background-color: rgba(0, 0, 0, 0.01);">
            <el-row type="flex" justify="center" class="mrow">
                <el-col :md="24" class="h-menu-title hidden-sm-and-down">
                    <div class="news-sub">DYNAMIC</div>
                    <div class="news-title" > 
                        <div class="news-type hover-hand" :class="hmlNewsIdx == 0 ? 'active':''"  @click="selectHml(0)">{{$t('newscenter.topBar.right.left')}}</div>
                        <div class="news-type hover-hand" :class="hmlNewsIdx == 1 ? 'active':''"  @click="selectHml(1)">{{$t('newscenter.topBar.right.right')}}</div>
                    </div>
                </el-col>
                <el-col :md="20" class="m-menu-title hidden-md-and-up">
                    <el-col :xs="12" :sm="12"  @click.native="selectHml(0)">
                        <div class="news-sub" :class="hmlNewsIdx == 0 ? 'active':''">DYNAMIC</div>
                        <div class="news-title" :class="hmlNewsIdx == 0 ? 'active':''" >
                            {{$t('newscenter.topBar.right.left')}}
                        </div>
                    </el-col>
                    <el-col :xs="12" :sm="12" @click.native="selectHml(1)" >
                        <div class="news-sub" :class="hmlNewsIdx == 1 ? 'active':''">DYNAMIC</div>
                        <div class="news-title" :class="hmlNewsIdx == 1 ? 'active':''">
                            
                            {{$t('newscenter.topBar.right.right')}}
                        </div>
                    </el-col>
                </el-col>
            </el-row>
            <el-row type="flex" justify="center" class="news-list" v-show="show" >
                <el-col :md="20" :sm="22" :xs="22">
                    <el-row :gutter="20">
                        <el-col :md="12" :sm="24" :xs="24" v-show="idx < 4"  @mouseover.native="onHover(1,idx);" v-for="(item,idx) in hmlCurrent" :key="idx" 
                         class="news-left item hover-hand">
                            <div class="left-main">
                                <div class="news-img" v-if=" idx == 0" :style="{backgroundImage:'url('+item.imgPath+')'}"></div>
                                <div class="news-detail" style="width: 100%; height: 150px; " 
                                    >
                                    <el-col :md="22" :xs="21" :sm="22">
                                        <el-col :md="24" style="display: flex;align-items: center;">
                                            <div class="iconfont mh-rili" style="font-size: 20px;" :style="{color:newsIdx==idx && moduleIdx == 1?'#fff':'#BA4D48'}"/>
                                            <div style="padding-left: 5px;">{{item.inputTime}}</div>    
                                        </el-col>
                                        <el-col :md="24" class="content-title">
                                            <div class=" hover-hand" > <a target="_blank" :href="item.pagePath">{{item.title}}</a> </div>
                                        </el-col>
                                        <el-col :md="24" :style="{'--clamp': 2}" class="content-msg"> <a target="_blank" :href="item.pagePath">{{item.subContent}}</a></el-col>
                                    </el-col>
                                    <el-col :md="2" :xs="2" :sm="2" style="height: 100%;display: flex;align-items: center;" >
                                        <p class="iconfont mh-right hover-hand"  style="font-size: 40px;" />
                                    </el-col>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
            <el-row type="flex" justify="center">
                <el-col :md="20" :sm="22" :xs="22" >
                    <div style="margin-top: 10px;text-align: right;">
                        <el-button type="text" style="color: #BA4D48;" > <a  href="newslist">查看更多>></a> </el-button>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
    export default{
        data() {
            return{
                idx:0,
                moduleIdx:0,
                cpnContentIdx:0,
                hmlContentIdx:0,
                newsIdx:0,
                show:false,
                bgImg:'https://scan-code.oss-cn-hangzhou.aliyuncs.com/menhu/service/ser-pro-01.png',
                hmlNewsIdx:0,
                hmlCurrent:[],
                cpnCurrent:[],
                //cpnNews:this.$t('newscenter.cpnNews'),
                //hmlNews:this.$t('newscenter.hmlNews'),
                cpnNews:[],
                empNews:[],
                baiAoNews:[],
                hmlNews:[]
            }
        },
        computed:{
            
        },
        mounted() {
              
            
        },
        created() {
            axios.get('https://www.drmums.com/article/list').then(
            //axios.get('http://localhost:8080/article/list').then(
              res=>{
                  this.newsList = res.data.data
                  this.cpnNews = this.newsList.cpn
                  this.empNews = this.newsList.emp
                  this.hmlNews = this.newsList.hml
                  this.baiAoNews = this.newsList.baiAo
                  let idx = this.hmlNewsIdx
                  switch(idx){
                      case 0:
                          //this.hmlCurrent = this.hmlNews.hml
                          //this.cpnCurrent = this.cpnNews.cpn
                          
                          this.hmlCurrent = this.hmlNews
                          this.cpnCurrent = this.cpnNews
                          break;
                      case 1:
                          //this.hmlCurrent = this.hmlNews.baiao
                          //this.cpnCurrent = this.cpnNews.emp
                          this.hmlCurrent = this.baiAoNews
                          this.cpnCurrent = this.empNews
                          break;
                  }
              }
            )
            
            this.show = true
        },
        methods:{
            changeCursor() {
                this.$el.style.cursor = 'pointer';
            },
            selectCpn(idx){
              this.cpnContentIdx = idx  
              switch(idx){
                  case 0:
                      this.cpnCurrent = this.cpnNews
                      break;
                  case 1:
                      this.cpnCurrent = this.empNews
                      break;
              }
            },
            redirect(id)
            {
                window.open("/newsinfo?id="+id,'_blank')
            },
            selectHml(idx){
                this.hmlNewsIdx = idx
                switch(idx){
                    case 0:
                        this.hmlCurrent = this.hmlNews
                        break;
                    case 1:
                        this.hmlCurrent = this.baiAoNews
                        break;
                }
            },
            selectModel(idx){
               // console.log(idx)
                this.idx = idx
                let sectionId = ''
                if(idx == 0){
                   this.scrollToSection('boma')
                }else{
                   this.scrollToSection('hml')
                }
                
            },
            scrollToSection(sectionId) {
              const section = document.getElementById(sectionId);
              if (section) {
                section.scrollIntoView({ behavior: 'smooth' });
              }
            },
            onHover(item,idx){
                this.moduleIdx = item
                if(idx == 0){
                    return true
                }
                this.newsIdx = idx
            },
            goList(){
                this.$router.push('/newslist')
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../assets/mh.scss';
    Page{
        margin: 0;
        padding: 0;
    }
  
    .cpn-news{
        // @media only screen and (min-width: 992px){
        //     height: 100vh;
        // }
        @media only screen and (max-width: 992px){
            margin-top: 0px;
        }
        margin-top: 100px;
        justify-content: center;
        display: flex;
        flex-direction: column;
        .mrow{
            @media only screen and (max-width: 992px){
                    margin-top: 0px;
            }
            margin-top: 50px;
        }
    }
    .news-list{
        .news-left{
            padding-left: 0px;
            padding-right: 0px;
            @media only screen and (max-width: 992px){
                margin-top: 20px;
            }
            margin-top: 10px;
            .left-main{
                border-radius: 5px;
                overflow: hidden;
                box-shadow: 0px 0px 5px #d4d4d4;
                .news-img{
                    @media only screen and (max-width: 992px){
                        height: 240px;
                    }
                    height: 320px;
                    background-size: cover;
                    background-position: center center
                }
                .news-detail{
                    @media only screen and (max-width: 992px){
                        padding: 15px 0;
                    }
                    padding: 15px;
                    .content-msg{
                        opacity: .7;
                        font-size: $h-font-16;
                        overflow: hidden;
                        /* height: 49px; */
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                    }
                    transition: all 0.5s ease-out;
                    &:hover{
                        background-color: #BA4D48;
                        color: #fff;
                    }
                }
                .content-title{
                   a{
                       text-decoration: none;
                       color: #000;
                   }
                   font-weight: bold;
                   font-size: $h-news-title;
                   padding: 3px 0;
                   overflow: hidden;
                   /* height: 49px; */
                   display: -webkit-box;
                   
                   -webkit-line-clamp: 1;
                   -webkit-box-orient: vertical;
                }
                
            }
            
        }
        
    }
    .page-top{
        height: 100vh;
        width: 100vw;
        position: relative;
        background-image: url('https://scan-code.oss-cn-hangzhou.aliyuncs.com/menhu/pgtp/top.jpg');
        background-size: cover;
        background-position: 70% center;
        align-items: center;
        .page-title{
            height: 100vh;
            align-items: center;
            display: flex;
        }
        
        h1{
            color: #fff;
            font-weight: bold;
        }
        h6{
            &+h6{
               border-top: 1px solid #acacac; 
               letter-spacing: 3px;
            }
            color: #fff;
            padding: 20px 0;
        }
    }
    .menu{
        width: 100%;
        position: absolute;
        z-index: 99;
        bottom: 0;
        letter-spacing: 3px;
        .item{
            transition: background .4s ease-in-out;
            padding: 15px 0;
            &+.item{
                border-left: 1px solid #acacac;
            }
        }
        .active{
            background-color: #BA4D48;
            color: #FFF;
        }
        .lose{
            background-color: #FFF;
            color: #000
        }
    }
    h4,h5{
        line-height: normal;
    }
    a {
      text-decoration: none; /* 去掉下划线 */
      color: inherit; /* 继承父元素颜色，状态不变 */
    }
    a:hover {
      color: none; /* 悬停时的颜色 */
    }
    a:active,
    a:focus {
      outline: none; /* 去掉点击时的虚线框 */
      color: #BA4D48; /* 点击时的颜色 */
    }
</style>